<div>
    <div class = "dialog-header-container">
        <h2 mat-dialog-title class="pd-t-5px">Copy Meeting / Follow-Up Meeting</h2>
        <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>
    <mat-divider class="mat-divider"></mat-divider>
    <div class="d-flex my-3 justify-content-between px-3">
       <div class="col-6 align-items-center p-0">
        <mat-radio-group [(ngModel)] = "popupIdentifier" aria-label="Select an option">
            <mat-radio-button value="Copy Meeting">Copy Meeting</mat-radio-button>
        </mat-radio-group>
       </div>
       <div class="col-6 align-items-center p-0">
        <mat-radio-group [(ngModel)] = "popupIdentifier" aria-label="Select an option">
            <mat-radio-button  value="Follow-up Meeting">Follow-Up Meeting</mat-radio-button>
        </mat-radio-group>
       </div>
    </div>
    <div *ngIf = "popupIdentifier == 'Copy Meeting'">
        <div mat-dialog-content class="row dialog-with-actions">
            <mat-form-field class="para-container input-field-formatting body-font-size p-0">
                <mat-label class="body-font-size">Meeting Title</mat-label>
                <input class="body-font-size" type="text"  matInput placeholder=""  [(ngModel)]= "newMeetingTitle" autocomplete="off"  >
            </mat-form-field>
            <div class="d-flex col-md-12 justify-content-between flex-wrap p-0">
                <mat-form-field class="col-md-5 para-container input-field-formatting body-font-size p-0">
                    <mat-label class="body-font-size">Meeting Date</mat-label>
                    <input [(ngModel)]= "meetingDate" placeholder="Meeting Date"  class="due-Date editable-assignedTo body-font-size" #input type="text" [matDatepicker]="picker" (focus)="picker.open()"  readonly matInput >
                    <!-- <input #input [formControl]="meetingDate" class="body-font-size" type="text"  [matDatepicker]="picker" (focus)="picker.open()"  readonly matInput placeholder="Meeting Date"> -->
                    <mat-datepicker (closed)="input.blur()" #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-md-5 para-container input-field-formatting body-font-size p-0">
                    <mat-label class="body-font-size">Meeting Time</mat-label>
                    <input class="body-font-size" type="text" mask="Hh:m0" [(ngModel)]= "currentTime" [dropSpecialCharacters]="false" matInput placeholder=""  name="name" autocomplete="off"  >
                </mat-form-field>
            </div>
            <mat-form-field class="para-container input-field-formatting body-font-size p-0">
                <mat-label class="body-font-size">Location</mat-label>
                <input [(ngModel)]= "location" class="body-font-size" type="text"  matInput placeholder=""  name="location" autocomplete="off"  >
            </mat-form-field>
            <div class="col-md-12 d-flex flex-wrap p-0">
                <div style="margin-right: 10px;">
                    <mat-checkbox [(ngModel)]= "includeAttendee" class="col-md-5 para-container input-field-formatting body-font-size">Include Meeting Attendee(s)</mat-checkbox>
                </div>
                <div>
                    <mat-checkbox [(ngModel)]= "includeAgenda" class="col-md-5 para-container input-field-formatting body-font-size">Include Meeting Agenda(s)</mat-checkbox>
                </div>
            </div>
        </div>
    
        <div class="d-flex justify-content-end" mat-dialog-actions>
            <!-- <span><button class="button-container primary" type="button" mat-flat-button color="primary" (click)="saveCopyMeeting()">Save</button></span>&nbsp;&nbsp;
            <span> -->
                <button class="button-container primary" type="button" mat-raised-button color="primary" (click)="saveCopyMeeting()">
                    SAVE
                </button>
                <button type="button" #editModalClose mat-raised-button color="primary" class="button-container primary" (click)="closeDialog()">
                    CANCEL
                </button>
            <!-- </span> -->
        </div>
    </div>
    <div *ngIf = "popupIdentifier == 'Follow-up Meeting'">
        <app-followup-meeting-popup [meetingInfo] = "followUpData"></app-followup-meeting-popup>
    </div>
</div>
